export const buildLogsTableTextLabels = (t) => ({
  body: {
    noMatch: t("viewlogs.table.body.noMatch"),
    toolTip: t("viewlogs.table.body.toolTip")
  },
  pagination: {
    next: t("viewlogs.table.pagination.next"),
    previous: t("viewlogs.table.pagination.previous"),
    rowsPerPage: t("viewlogs.table.pagination.rowsPerPage"),
    displayRows: t("viewlogs.table.pagination.displayRows")
  },
  toolbar: {
    search: t("viewlogs.table.toolbar.search"),
    downloadCsv: t("viewlogs.table.toolbar.downloadCsv"),
    print: t("viewlogs.table.toolbar.print"),
    viewColumns: t("viewlogs.table.toolbar.viewColumns"),
    filterTable: t("viewlogs.table.toolbar.filterTable")
  },
  filter: {
    all: t("viewlogs.table.filter.all"),
    title: t("viewlogs.table.filter.title"),
    reset: t("viewlogs.table.filter.reset")
  },
  viewColumns: {
    title: t("viewlogs.table.viewColumns.title"),
    titleAria: t("viewlogs.table.viewColumns.titleAria")
  },
  selectedRows: {
    text: t("viewlogs.table.selectedRows.text"),
    delete: t("viewlogs.table.selectedRows.delete"),
    deleteAria: t("viewlogs.table.selectedRows.deleteAria")
  }
});
